<div class="validate-user-container">
  <!-- Success State -->
  <div *ngIf="isAlreadyApproved || validateSuccess" class="success-container">
    <div class="success-icon">
      <i class="dx-icon-check"></i>
    </div>
    <p class="success-message">Your account validation has been completed.</p>
    <p class="signin-message">
      You may now
      <a [routerLink]="['/user/login']">sign in</a>
      to your account.
    </p>
  </div>

  <!-- Missing Information State -->
  <div *ngIf="missingInformation" class="error-container">
    <p class="error-message">
      The registration information could not be found. Please
      <a [routerLink]="['/user/validate']">re-validate</a>
      the email address again.
    </p>
    <p class="error-submessage">
      This will send a new email to your email account with new validation
      information.
    </p>
  </div>
</div>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#loginContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
  message="Validating Email..."
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
